export default __webpack_public_path__ + "static/media/phone-rainy.323f708a.jpg";